import { isOnboardedInfoFetched } from 'src/modules/onboarding/selectors/onboardingSelectors';
import { isUserDataFetched, getUserRole } from 'src/modules/user/selectors/userSelectors';
import { getVideoSessions } from 'src/modules/videoSessions/selectors/videoSessionsSelectors';

import { createSelector } from 'reselect';
import { RootState } from 'src/config/rootStore';
import { Role } from 'src/modules/user/models/user';

export const isInitialDataFetched = createSelector(
    isUserDataFetched,
    isOnboardedInfoFetched,
    (state: RootState) => state.providers.myProviders,
    getVideoSessions,
    getUserRole,
    (userDataFetched, onboardedInfoFetched, providers, sessions, userRole) => {
        if (userRole === Role.COACH) {
            return userDataFetched;
        }
        return userDataFetched && onboardedInfoFetched && providers != null && sessions != null;
    },
);
